export enum MenuItems {
    isAdd = "isAdd",
    isDelete = "isDelete",
    isEdit = "isEdit",
    isNotes = "isNotes",
    isNotification = "isNotification",
    isStatus = "isStatus",
    isView = "isView",
    isWorkspace = "isWorkspace",
    isProgress = "isProgress",
    isScorecard = "isScorecard",
    isStatistics = "isStatistics",
    isTaskManagement = "isTaskManagement",
    isDocuments = "isDocuments"
}

export enum Modules {
    FacilityMaster = "Facility Master",
    CarrierMaster = "Carrier Master",
    PatientMaster = "Patient Master",
    FacilityInfo = "Facility Info",
    BulkUploadVob = "Bulk Upload Vob",
    VobExplorer = "Vob Explorer",
    VOB = "VOB",
    Authorisation = "UR",
    DocumentVault = "Document Vault",
    UserManagement = "User Management",
    Announcement = "Announcement",
    DiagnosticCode = "Diagnostic Code",
    Modulemaster = "Module Master",
    DocumentWorkflow = "Document Workflow",
    StatusFlowMaster = "Status Workflow",
    FacilityDocument = "Facility Documents",
    ServiceMaster = "Service Master",
    ServiceTypeMaster = "Service Type Master",
    FundMaster = "Fund Master",
    Taxonomy = "Taxonomy",
    MessageConfiguration = "Message Configuration",
    Department = "Department",
    CallRecordAnalytics = "Call Record Analytics",
    ClaimsBilled = "Claims Billed",
    PaymentSummary = "Payment Summary",
    PaymentDetail = "Payment Detail",
    PatientStatement = "Patient Statement",
    Aging = "Current Payer Breakdown",
    AgingSummary = "AR Aging Summary",
    UrDaily = "UR Daily Authorizations",
    URReview = "UR Upcoming Review",
    PayerPriorityBalance = "Balance By Payer Priority",
    ActivitySummary = "Activity Summary",
    PatientBalance = "Patient Balance Report",
    PayerTypeBreakdown = "Payer Type Breakdown",
    TPN = "TPN",
    RefundRequest = "Refund Request",
    TPNMaster = "Third Party Master",
    PaymentTask = "Payment Task",
    UploadTypeMaster = "Upload Type Master",
    FacilityIdentifier = "Facility Identifier",
    EmailTemplate = "Email Template",
    SchedulerSetting = "Scheduler Settings",
    Permission = "Permission",
    DailyProductionReport = "Daily Production Report",
    QualityReport = "Quality Report",
    CallTimeReport = "Call Metrics Report",
    TATReport = "TAT Report",
    SpecialistBreakReport = "Specialist Break Report",
    VobVolumeReport = "VOB Volume Report",
    ReAssignmentReport = "Reassignment Or Rework Report",
    MissingInformationReport = "Missing Information Report",
    FacilityPayerReport = "Facility/Payer Report",
    SpecialistPerformanceReport = "Specialist Performance Report",
    Billing = "Billing",
    ScheduledReports = "Scheduled Reports",
    RoleBuilder = "Role Builder"
}
